import type { FC } from 'react';
import React from 'react';

import type { IStickyTableHeaderProps } from '../models';

export const StickyTableHeader: FC<IStickyTableHeaderProps> = ({
    Layout,
    Sticky,
    children,
    dataTestId = 'sticky-table-header',
}) => {
    return (
        <Sticky>
            <Layout dataTestId={dataTestId} hasPadding={false}>
                {children}
            </Layout>
        </Sticky>
    );
};
